import * as Common from '@/tenant/common';

export class SalesSummaryReportQuery extends Common.Query {
    constructor(){
        super("SalesSummaryReportQuery", null);
    }
    public templateId:number=0;
    public startDate: Date = null;
    public endDate: Date = null;
    public segment: Common.Segment = null;
    public counterpart: Common.Counterpart = null;
    public counterpartCategory: Common.Category = null;
    public commodity: Common.Commodity = null;
    public commodityCategory: Common.Category = null;
    public deliveryDateFrom: Date = new Date().getCalendarDate();
    public deliveryDateTo: Date = new Date().getCalendarDate();
    public sort: number = 0;
    public itemCategory: number = 0;
    public summaryCategory1: number = 0;
    public summaryCategory2: number = 0;
    // public includeProspect: boolean = false;
    public onExcelExport:boolean = false;       
    public searchDeliveryDate: boolean = false;    
    public includeProspectType: Common.IncludeProspectTypes = Common.IncludeProspectTypes.None;
}

export class SalesSummaryReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='SalesSummaryReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}

export enum SummarySortTypes {
  ItemCategory = 0,
  SalesRanking = 1,
  ProfitRanking = 2,
  PurchaseRanking = 3,
  ProfitRatioRanking = 4,
}

export enum SummaryCategoryTypes
    {
        None = 0,
        ClosingDate = 1,
        SalesBookDate = 2,
        PurchaseBookDate = 3,
        PIC = 4,        
        DeliveryDate = 5,
        Segment = 11,
        SegmentCategory1 = 12,
        SegmentCategory2 = 13,
        SegmentCategory3 = 14,
        SegmentCategory4 = 15,
        SegmentCategory5 = 16,
        SegmentCategory6 = 17,
        Counterpart = 21,
        CounterpartCategory1 = 22,
        CounterpartCategory2 = 23,
        CounterpartCategory3 = 24,
        CounterpartCategory4 = 25,
        CounterpartCategory5 = 26,
        CounterpartCategory6 = 27,
        Receiver = 28,
        Payer = 29,
        Commodity = 31,
        CommodityCategory1 = 32,
        CommodityCategory2 = 33,
        CommodityCategory3 = 34,
        CommodityCategory4 = 35,
        CommodityCategory5 = 36,
        CommodityCategory6 = 37,
        VoucherNo = 43,
        ProjectItemNo = 51,
        ProjectItemCustomer = 52,
        ReceiverName = 53,
    }
export enum IncludeProspectTypes
    {
        None = 0,
        IncludeDeliverySchedule = 1,  // 出荷予定を含める
        IncludeDelivered = 2, //出荷済みを含める
    }